import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export enum LegalUserAction {
    FETCH_LEGAL_USER_REGISTRATION = "legalUser/fetchLegalUserRegistration",
    INITIATE_IDENTIFICATION = "legalUser/initiateIdentification",
}

let config = {
    headers: {
        "Content-Type": "application/json",
        'Access-Control-Allow-Origin': '*',
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Credentials": true,
    }
};

export const fetchLegalUserRegistration = createAsyncThunk(
    LegalUserAction.FETCH_LEGAL_USER_REGISTRATION,
    async (registrationId: string, thunkAPI) => {
        try {
            const response = await axios.get(`/api/users/legal/registration?registrationId=${registrationId}`, config).then(res => res.data);
            return response;

        } catch (error: any) {
            return thunkAPI.rejectWithValue(error?.response?.data?.message  || "Registration token generation failed");
        }
    }
);

export const initiateIdentification = createAsyncThunk(
    LegalUserAction.INITIATE_IDENTIFICATION,
    async (registrationId: string, thunkAPI) => {
        try {
            const response = await axios.post(`/api/users/legal/${registrationId}/identification/initiate`, {}, config).then(res => res.data);
            if (response.state === "ERROR" && response.result) {
                const error = response.result;
                return thunkAPI.rejectWithValue(error.description || error.message || "Identification initiation failed");
            }
            
            return response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error?.response?.data?.message || "Identification initiation failed");
        }
    }
);

export const legalUserActions = {
    fetchLegalUserRegistration,
    initiateIdentification,
};